var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2468 21.9999C10.8918 21.9999 9.57084 21.9849 8.26384 21.9579C6.59184 21.9249 5.43484 20.8409 5.24584 19.1289C4.93084 16.2889 4.39184 9.59491 4.38684 9.52791C4.35284 9.11491 4.66084 8.75291 5.07384 8.71991C5.48084 8.70891 5.84884 8.99491 5.88184 9.40691C5.88684 9.47491 6.42484 16.1459 6.73684 18.9639C6.84384 19.9369 7.36884 20.4389 8.29484 20.4579C10.7948 20.5109 13.3458 20.5139 16.0958 20.4639C17.0798 20.4449 17.6118 19.9529 17.7218 18.9569C18.0318 16.1629 18.5718 9.47491 18.5778 9.40691C18.6108 8.99491 18.9758 8.70691 19.3848 8.71991C19.7978 8.75391 20.1058 9.11491 20.0728 9.52791C20.0668 9.59591 19.5248 16.3069 19.2128 19.1219C19.0188 20.8689 17.8648 21.9319 16.1228 21.9639C14.7898 21.9869 13.5038 21.9999 12.2468 21.9999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.708 6.98926H3.75C3.336 6.98926 3 6.65326 3 6.23926C3 5.82526 3.336 5.48926 3.75 5.48926H20.708C21.122 5.48926 21.458 5.82526 21.458 6.23926C21.458 6.65326 21.122 6.98926 20.708 6.98926Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4406 6.98924C16.3026 6.98924 15.3146 6.17824 15.0906 5.06224L14.8476 3.84624C14.7966 3.66124 14.5856 3.50024 14.3456 3.50024H10.1126C9.87258 3.50024 9.66158 3.66124 9.60058 3.89224L9.36758 5.06224C9.14458 6.17824 8.15558 6.98924 7.01758 6.98924C6.60358 6.98924 6.26758 6.65324 6.26758 6.23924C6.26758 5.82524 6.60358 5.48924 7.01758 5.48924C7.44358 5.48924 7.81358 5.18524 7.89758 4.76724L8.14058 3.55124C8.38758 2.61924 9.19458 2.00024 10.1126 2.00024H14.3456C15.2636 2.00024 16.0706 2.61924 16.3076 3.50624L16.5616 4.76724C16.6446 5.18524 17.0146 5.48924 17.4406 5.48924C17.8546 5.48924 18.1906 5.82524 18.1906 6.23924C18.1906 6.65324 17.8546 6.98924 17.4406 6.98924Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.ae66d946de486d371de73f748d0c254d.svg";
export { ForwardRef as ReactComponent };